import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';
import { Shield, Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function BootstrapAdmin() {
  const [email, setEmail] = useState('');
  const [secret, setSecret] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleBootstrap = async (e) => {
    e.preventDefault();
    
    if (!email || !secret) {
      toast.error('Please fill in all fields');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API}/api/auth/bootstrap-admin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, secret })
      });

      const data = await res.json();

      if (res.ok) {
        toast.success('You are now an admin! Redirecting to login...');
        setSuccess(true);
        setTimeout(() => {
          window.location.href = '/auth';
        }, 2000);
      } else {
        toast.error(data.detail || 'Failed to bootstrap admin');
      }
    } catch (error) {
      toast.error('Failed to connect to server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <div className="glass-card p-8 max-w-md w-full">
        <div className="text-center mb-6">
          <Shield className="h-12 w-12 text-primary mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-white mb-2">Setup Admin Account</h1>
          <p className="text-zinc-400 text-sm">
            This page is for initial setup only. It will only work if no admin exists yet.
          </p>
        </div>

        {success ? (
          <div className="text-center text-green-400">
            <p className="text-lg font-semibold">✓ Admin account created!</p>
            <p className="text-sm mt-2">Redirecting to login...</p>
          </div>
        ) : (
          <form onSubmit={handleBootstrap} className="space-y-4">
            <div>
              <label className="block text-sm text-zinc-400 mb-1">Your Email</label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="administration@wrappedinmusic.com"
                className="input-dark"
              />
            </div>
            <div>
              <label className="block text-sm text-zinc-400 mb-1">Setup Secret</label>
              <Input
                type="password"
                value={secret}
                onChange={(e) => setSecret(e.target.value)}
                placeholder="Enter the setup secret"
                className="input-dark"
              />
              <p className="text-xs text-zinc-500 mt-1">
                Hint: wrappedinmusic2024
              </p>
            </div>
            <Button 
              type="submit" 
              className="btn-primary w-full"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Loader2 className="h-4 w-4 animate-spin mr-2" />
                  Setting up...
                </>
              ) : (
                <>
                  <Shield className="h-4 w-4 mr-2" />
                  Make Me Admin
                </>
              )}
            </Button>
          </form>
        )}

        <p className="text-center text-zinc-500 text-xs mt-6">
          Already have an admin? <a href="/auth" className="text-primary hover:underline">Go to Login</a>
        </p>
      </div>
    </div>
  );
}
